import styled from 'styled-components'
import { colours } from '@qflow/theme'

export const TitleBar = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 0.5rem;

  h4 {
    font-size: 1.125rem;
    margin: 0 0 1rem 0.125rem;
  }
`
export const TitleBarIcon = styled.div`
  display: flex;
  justify-content: end;
  min-height: 1.25rem;
  min-width: 1.25rem;
  margin-top: 5px;
  margin-left: 2px;
`
export const Tiles = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr 1fr 1fr 1fr;
`
export const Tile = styled.div<{ onClick?: () => void }>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-basis: 20%;
  justify-content: space-between;
  padding: 0.625rem 0.75rem;
  background-color: ${colours.CONTROL_PANEL_GREY};
  border-radius: 10px;
  gap: 0.5rem;
  min-height: 100px;

  h5 {
    font-size: 0.875rem;
    margin-bottom: 0.125rem;
  }

  ol,
  ul {
    margin: 0;
    padding-left: 1.25rem;
  }

  ${({ onClick }) =>
    onClick &&
    `
    &:hover {
    background-color: ${colours.LIGHT_GREY};
    cursor: pointer;
  `}
`
export const TileRow = styled.div`
  display: flex;
  justify-content: space-between;
`
export const TileTitle = styled.div`
  font-family: "Jakarta Sans", Inter, Roboto !important;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.25rem;
  margin-bottom: 0.125rem;
  word-break: break-word;

  @media (min-width: 1600px) {
    font-size: 0.875rem;
  }
}
`
export const TileNumber = styled.div`
  font-size: 1.25rem;
  font-weight: 500;
`
